module.exports = __webpack_public_path__ + "static/media/rupee.53f0d95a.svg";